module.exports = __webpack_public_path__ + "img/gavel.ffcb8dec.png";